import React from "react";
import ReportsView from "../components/ReportsView";

function Reports({
  currentMenuItem,
  setCurrentMenuItem,
  projectId,
  setProjectId,
  reportId,
  setReportId,
  user,
}) {
  return (
    <div>
      <main className="flex-1">
        <div className="py-6">
          <ReportsView
            currentMenuItem={currentMenuItem}
            setCurrentMenuItem={setCurrentMenuItem}
            projectId={projectId}
            setProjectId={setProjectId}
            reportId={reportId}
            setReportId={setReportId}
            user={user}
          />
        </div>
      </main>
    </div>
  );
}

export default Reports;
